module.exports = __webpack_public_path__ + "img/04.7e7f1822.jpg";